import { defineStore } from "pinia";
import { ref } from "vue";
import { addQueryParamToUrl } from "@/utils/functions";
import { useMainStore } from "@/stores/main";
import { useQuestionsStore } from "@/stores/questions";
import { useSupplementsStore } from "@/stores/supplements";
import router from "@/router/index";
import { sanitizeUrlFromQueryParamsWithNoValue, sanitizeUrlFromQuerySpecialCharacter } from "@/utils/functions";
import { sanitizeUrl } from "@braintree/sanitize-url";

export enum QuarterlySubscriptionVersion {
  Control = "",
  B = "B",
}

export enum OrderRecipeABVersion {
  Control = "",
  B = "B",
}

export const useABVersionsStore = defineStore("abVersions", () => {
  const quarterlySubscriptionABVersion = ref<QuarterlySubscriptionVersion>(QuarterlySubscriptionVersion.Control);

  const setQuarterlySubscriptionABVersion = (version: QuarterlySubscriptionVersion) => {
    quarterlySubscriptionABVersion.value = version;
  };

  const orderRecipeABVersion = ref<OrderRecipeABVersion>(OrderRecipeABVersion.Control);

  const setOrderRecipeABVersion = (version: OrderRecipeABVersion) => {
    orderRecipeABVersion.value = version;
  };

  const constructShopifyPPLink = () => {
    const mainStore = useMainStore();
    const supplementsStore = useSupplementsStore();
    const questionsStore = useQuestionsStore();

    const envLink = import.meta.env.VITE_SHOPIFY_PP_LINK;
    if (!envLink) return "";

    let url = envLink.replace("{formula_draft_uuid}", supplementsStore.formulaDraftUuid);
    url = addQueryParamToUrl(url, { key: "country_code", value: mainStore.ipLocationCountryCode });
    url = addQueryParamToUrl(url, {
      key: "formula_email",
      value: questionsStore.lifestyleStore.email,
    });
    Object.entries(router.currentRoute.value.query).forEach(([key, value]) => {
      url += `&${key}=${value}`;
    });

    const cleanUrl = sanitizeUrlFromQueryParamsWithNoValue(url);
    const cleanerUrl = sanitizeUrlFromQuerySpecialCharacter(cleanUrl);
    const sanitizedUrl = sanitizeUrl(cleanerUrl);

    return sanitizedUrl;
  };

  return {
    quarterlySubscriptionABVersion,
    setQuarterlySubscriptionABVersion,
    orderRecipeABVersion,
    setOrderRecipeABVersion,
    constructShopifyPPLink,
  };
});
